// extracted by mini-css-extract-plugin
export default {"actions":"Actions_actions__NsiZx","list":"Actions_list__lc387","favorite":"Actions_favorite__J4GXw","button":"Actions_button__ZR7Nm"};